import { timetableAPI } from '@/api'
import { ApiResult } from '@modals/RequiredEmailConfirmation/components/RequiredEmailConfirmationModal/utils/api'

export interface IStudentLessonStatus {
  id: number
  student: IUser
  status: string | null
  comment: string
  joined_after_lesson?: boolean
}

const MOCK_STUDENTS_LESSON_STATUSES: IStudentLessonStatus[] = [
  {
    id: 1,
    student: {
      id: 2800,
      name: 'Иванов Иван',
      email: 'ivanov@example.com',
      avatar_path: '',
    } as IUser,
    status: '5',
    comment: 'Был на занятии',
  },
  {
    id: 2,
    student: {
      id: 2905,
      name: 'Петрова Анна',
      email: 'petrova@example.com',
      avatar_path: '',
    } as IUser,
    status: '0',
    comment: '',
  },
  {
    id: 3,
    student: {
      id: 2958,
      name: 'Сидоров Максим',
      email: 'sidorov@example.com',
      avatar_path: '',
    } as IUser,
    status: '10',
    comment: 'Предупредил об отсутствии',
  },
]

export const getStudentsForLessonReport = async (
  lessonId: number,
): Promise<ApiResult<IStudentLessonStatus[]>> => {
  try {
    const res = await timetableAPI.studentsLessonStatuses(lessonId)
    const data = res?.data?.data
    const isSuccessStatus =
      res?.data?.status === undefined || res?.data?.status === 'success'

    return {
      data,
      success: isSuccessStatus && res?.data?.success !== false,
      error:
        res?.data?.error ||
        res?.data?.message ||
        'Не удалось загрузить учеников занятия',
    }
  } catch (error) {
    console.error('Ошибка getStudentsForLessonReport:', error)
    return {
      data: [],
      success: false,
      error: error instanceof Error ? error.message : String(error),
    }
  }
}

export const saveStudentsLessonStatuses = async (
  lessonId: number,
  users: IStudentLessonStatus[],
  lessonStatus: string,
  setStatusesInAttendanceJournal: boolean,
  lessonComment: string,
  lessonDuration?: number,
): Promise<ApiResult<Boolean>> => {
  try {
    const data = new FormData()
    data.append('lesson_id', String(lessonId))
    data.append('lesson_status', lessonStatus)
    data.append('lesson_comment', lessonComment)
    if (lessonDuration !== undefined) {
      data.append('lesson_time_change', String(lessonDuration))
    }
    data.append(
      'set_statuses_in_attendance_journal',
      setStatusesInAttendanceJournal ? '1' : '0',
    )
    data.append(
      'data',
      JSON.stringify(
        users.map((u) => ({
          id: u.id,
          student_id: u.student.id,
          status: u.status,
          comment: u.comment,
        })),
      ),
    )

    const res = await timetableAPI.updateStudentsLessonStatuses(data)

    return {
      data: res?.data?.status === 'success',
      success: res?.data?.status === 'success' || res?.data?.success === true,
      error:
        res?.data?.error ||
        res?.data?.message ||
        'Не удалось сохранить статусы учеников',
    }
  } catch (error) {
    console.error('Ошибка saveStudentsLessonStatuses:', error)
    return {
      data: null,
      success: false,
      error: error instanceof Error ? error.message : String(error),
    }
  }
}
